import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ToastService } from "src/app/shared/toast.service";
import { BulkConfigurationType } from "../../models/BulkConfigurationType.enum";
import { BulkService } from "../../services/bulk.service";
import { BulkConfigurationService } from "../../services/bulk-configuration.service";
import { BulkConfigurationSettingDto } from "../../models/BulkConfigurationSettingDto";
import { first } from "rxjs/operators";

@Component({
  selector: "app-admin-panel-bulk-upload-dialog",
  templateUrl: "./admin-panel-bulk-upload-dialog.component.html",
  styleUrls: ["./admin-panel-bulk-upload-dialog.component.scss"],
})
export class AdminPanelBulkUploadDialogComponent implements OnInit {
  @Output() decision: EventEmitter<boolean> = new EventEmitter();

  bulkUploadForm: FormGroup;

  uploadErrors: string;
  fileToUpload: File | any;

  bulkConfigurationTypeOptions: BulkConfigurationSettingDto[];

  constructor(
    public activeModal: NgbActiveModal,
    private _bulkService: BulkService,
    private _bulkConfigurationService: BulkConfigurationService,
    private _toastService: ToastService
  ) {}

  ngOnInit() {
    this.bulkUploadForm = new FormGroup({
      bulkConfigurationType: new FormControl("", Validators.required),
      fileToUpload: new FormControl("", [Validators.required]),
    });
    this.filterBulkConfigurationTypesForUser();
  }

  filterBulkConfigurationTypesForUser() {
    this._bulkConfigurationService
      .getBulkConfigurationsForCurrentUser()
      .pipe(first())
      .subscribe(
        (res) => {
          this.bulkConfigurationTypeOptions = res;
        },
        () => this.showErrorWhileGettingBulkConfigurationTypes()
      );
  }

  selectFile(e: any) {
    this.fileToUpload = e.target.files[0];
    this.uploadErrors = "";
  }

  public onDownloadSampleFile() {
    // INFO: https://javascript.info/popup-windows
    this._bulkService
      .getSampleFile(this.bulkUploadForm.value.bulkConfigurationType)
      .pipe(first())
      .subscribe(
        (res) => {
          // TODO: This is temporary, must be made in API
          res.fileName =
            BulkConfigurationType[
              this.bulkUploadForm.value.bulkConfigurationType
            ] + "_sample.csv";
          this.downloadFile(res);
        },
        (err) => {
          this.showErrorWhileGettingBulkSampleFile();
        }
      );
  }

  downloadFile(response: {
    fileName: string;
    fileType: string;
    data: ArrayBuffer;
  }) {
    let blob = new Blob([response.data], { type: response.fileType });

    const data = window.URL.createObjectURL(blob);
    var link = document.createElement("a");
    link.href = data;
    link.download = response.fileName;
    link.click();

    setTimeout(function () {
      // for Firefox it is necessary to delay revoking the ObjectURL
      window.URL.revokeObjectURL(data);
    }, 100);
  }

  onUpload() {
    if (!this.validateForm()) return;

    if (!this.fileToUpload) {
      this._toastService.showWarnToast(
        $localize`No file`,
        $localize`No file to upload.`
      );
      return;
    }

    var bulkConfigType = this.bulkUploadForm.get("bulkConfigurationType").value;
    this._bulkService
      .uploadBlobFileCSV(this.fileToUpload, bulkConfigType)
      .then(() => {
        this.activeModal.close("ok");
      })
      .catch((error) => {
        this.uploadErrors = error?.error?.detailedError?.message;
      });
  }

  onCancel() {
    this.activeModal.close("cancel");
  }

  validateForm() {
    if (!this.bulkUploadForm.valid) {
      Object.keys(this.bulkUploadForm.controls).forEach((field) => {
        const control = this.bulkUploadForm.get(field);
        control.markAsTouched({ onlySelf: true });
      });
      return false;
    }
    return true;
  }

  private showErrorWhileGettingBulkConfigurationTypes() {
    this._toastService.showErrorToast(
      $localize`Something went wrong`,
      $localize`Something went wrong while retrieving the bulk configuration types.`
    );
  }

  private showErrorWhileGettingBulkSampleFile() {
    this._toastService.showErrorToast(
      $localize`Something went wrong`,
      $localize`Something went wrong while retrieving the bulk sample file.`
    );
  }
}
